import type { BreadcrumbProps } from '@/components/Breadcrumb';
import { Breadcrumb } from '@/components/Breadcrumb';
import { generateDataTestId } from '@/lib/tests';

import * as GS from '../ProductDetail.styles';

interface BreadcrumbsProps extends BreadcrumbProps {
  mdHidden?: boolean;
  mdVisible?: boolean;
}

export const Breadcrumbs = ({
  items,
  withJsonLd,
  ...visibilityProps
}: BreadcrumbsProps) => (
  <GS.BreadcrumbsWrapper
    data-test-id='BreadcrumbsWrapper'
    {...visibilityProps}
    {...generateDataTestId('productBreadcrumbs', 'wrapper')}
  >
    <Breadcrumb
      data-test-id='BreadcrumbsItem'
      isProductDetailsPage={true}
      items={items}
      withJsonLd={withJsonLd}
    />
  </GS.BreadcrumbsWrapper>
);
